import { createContext, useContext } from "react";

/**
 * Base path under which the shared admin/dealer panel pages are mounted.
 *
 * The superadmin panel lives at `/admin/*` and the dealer panel at `/dealer/*`,
 * but both reuse the exact same page components (TenantsTable, AdminDashboardPage,
 * AdminBillingPage, AdminTenantDetailPage, …). Those pages build internal
 * navigation links from this base path so they render correctly under either
 * shell.
 *
 * Defaults to `"/admin"` so existing superadmin rendering keeps working without
 * a provider; `DealerShell` overrides it with `"/dealer"`.
 */
export const AdminBasePathContext = createContext<string>("/admin");

/** Read the current admin/dealer base path (`/admin` by default). */
export function useAdminBasePath(): string {
  return useContext(AdminBasePathContext);
}
